<script setup lang="ts">
const i18nHead = useLocaleHead({
  dir: true,
  lang: true,
  key: 'hid',
  seo: true
})

useHeadSafe({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
    // @ts-ignore
    dir: i18nHead.value.htmlAttrs!.dir
  },
  link: [...(i18nHead.value.link || [])],
  meta: [...(i18nHead.value.meta || [])]
})

const layoutCustomProps = useAttrs()
const route = useRoute()
const activePath = computed(() => route.path.split('/')[1])

const { data: user, status } = useAuth()
</script>

<template>
  <div
    :id="layoutCustomProps.id as string"
    :class="'student-layout ' + (layoutCustomProps.class || '')"
  >
    <LayoutNavbar v-if="status === 'authenticated'" :active="activePath" :user="user" />
    <LandingNavBar v-else />

    <main>
      <slot />
    </main>
  </div>
</template>

<style lang="scss">
.student-layout {
  padding-top: var(--navbarHeight);

  main {
    min-height: calc(100dvh - var(--navbarHeight));
  }
}
</style>
